package ru.cleardocs.lkweb.pages

enum class MainViewState {
    Profile,
    Connectors,
    Plans,
}
